import { call, put } from 'redux-saga/effects';
// COMMON
import { notification } from 'elements';
import * as actionTypes from '@/redux/new_store_structure/actions/actionsTypes';
import { wsClient } from '@/index';

export function* getHolderAbsenceReportSaga(action) {
  /**
   * @param clientId
   * @param day
   */
  yield put({
    type: actionTypes.HOLDER_ABSENCE_REPORT_START,
  });
  const { params } = action.payload;
  const requestPayload = {
    messageType: 'core.holder.get-holder-absence-report',
    payload: {
      ...params,
    },
  };

  try {
    const { payload } = yield wsClient.request(requestPayload);
    yield put({
      type: actionTypes.HOLDER_ABSENCE_REPORT_SUCCESS,
      payload,
    });
  } catch (error) {
    console.log('ERR', error);
    yield put({
      type: actionTypes.HOLDER_ABSENCE_REPORT_FAILED,
      payload: { error },
    });
    yield call(notification.error, {
      message: 'Error',
      description: error.message,
      placement: 'bottomLeft',
    });
  }
}



// WEBPACK FOOTER //
// ./src/redux/new_store_structure/sagas/holderAbsenceReport.js